/**
 * @author tomekbuszewski
 * @since 2019-6-12
 */

import * as React from "react";
import styled from "styled-components";

import { ITheme } from "@ui/themes/ThemeInterface";
import { transition } from "@ui/helpers";

interface Props {
  active?: boolean;
  children: React.ReactNode;
  className?: string;
  id: string;
  scroll?: number;
  theme: ITheme;
}

const SidebarLinkComponent = (props: Props) => (
  <span className={props.className}>{props.children}</span>
);

const SidebarLink = styled(SidebarLinkComponent)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${props =>
    props.active ? props.theme.palette.grey800 : props.theme.palette.grey600};
  background: ${props => props.active && props.theme.palette.grey20};
  line-height: ${props => props.theme.fonts.lineHeights.normal};
  padding: ${props => props.theme.margins.base};
  margin-bottom: ${props => props.theme.margins.base};
  border-radius: ${props => props.theme.buttons.borderRadius};
  cursor: pointer;
  transition: ${transition(["background", "color"])};

  &:hover {
    background: ${props => props.theme.palette.grey20};
    color: ${props => props.theme.palette.grey800};
    transition: ${transition(["background", "color"])};

    svg {
      color: ${props => props.theme.palette.grey800};
    }
  }
`;

export { SidebarLink };
